import { render, staticRenderFns } from "./ToggleButton.vue?vue&type=template&id=5a8722d4&scoped=true&"
import script from "./ToggleButton.vue?vue&type=script&lang=js&"
export * from "./ToggleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8722d4",
  null
  
)

export default component.exports